import { render, staticRenderFns } from "./Rgkstock.vue?vue&type=template&id=48b848fb&scoped=true&"
import script from "./Rgkstock.vue?vue&type=script&lang=js&"
export * from "./Rgkstock.vue?vue&type=script&lang=js&"
import style0 from "./Rgkstock.vue?vue&type=style&index=0&id=48b848fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b848fb",
  null
  
)

export default component.exports